import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Preserve follow-list snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:memberId|nextCursorFollowId|followId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const followListApi = {
  listFollowers: (memberId, params = {}, options = {}) => travelClient.get(
    travelEndpoints.memberFollowers(memberId),
    { params, signal: options.signal, ...snowflakeJson },
  ),
  listFollowing: (memberId, params = {}, options = {}) => travelClient.get(
    travelEndpoints.memberFollowing(memberId),
    { params, signal: options.signal, ...snowflakeJson },
  ),
};
